import {
  ROTATE_INTEGRATION_KEY_REQUEST,
  ROTATE_INTEGRATION_KEY_SUCCESS,
  ROTATE_INTEGRATION_KEY_ERROR,
  CLEAR_ROTATED_INTEGRATION_KEY,
  FETCH_INTEGRATION_IMPORT_RUNS_REQUEST,
  FETCH_INTEGRATION_IMPORT_RUNS_SUCCESS,
  FETCH_INTEGRATION_IMPORT_RUNS_ERROR,
  IMPORT_JSON_PAYLOAD_REQUEST,
  IMPORT_JSON_PAYLOAD_SUCCESS,
  IMPORT_JSON_PAYLOAD_ERROR,
  IMPORT_JSON_PAYLOAD_RESET,
} from "../types";

const initialState = {
  // The inbound settings live in state.apiImport.settings (the shared
  // /portfolio/api-settings resource) — this slice only holds the
  // exchange-surface extras.
  rotating: false,
  // { api_key (plaintext — shown once, cleared on dismiss), api_key_prefix }
  rotatedKey: null,
  rotateError: null,

  runs: [],
  runsLoading: false,
  runsError: null,

  importing: false,
  // POST /actuals/import/json response:
  // { status, message, totalLines, integratedLines, rejectedLines, batches, errors }
  importResult: null,
  importError: null,
};

export default function integrationReducer(state = initialState, action) {
  switch (action.type) {
    case ROTATE_INTEGRATION_KEY_REQUEST:
      return { ...state, rotating: true, rotateError: null };
    case ROTATE_INTEGRATION_KEY_SUCCESS:
      return { ...state, rotating: false, rotatedKey: action.payload };
    case ROTATE_INTEGRATION_KEY_ERROR:
      return { ...state, rotating: false, rotateError: action.payload };
    case CLEAR_ROTATED_INTEGRATION_KEY:
      return { ...state, rotatedKey: null };

    case FETCH_INTEGRATION_IMPORT_RUNS_REQUEST:
      return { ...state, runsLoading: true, runsError: null };
    case FETCH_INTEGRATION_IMPORT_RUNS_SUCCESS:
      return { ...state, runsLoading: false, runs: action.payload };
    case FETCH_INTEGRATION_IMPORT_RUNS_ERROR:
      return { ...state, runsLoading: false, runsError: action.payload };

    case IMPORT_JSON_PAYLOAD_REQUEST:
      return { ...state, importing: true, importResult: null, importError: null };
    case IMPORT_JSON_PAYLOAD_SUCCESS:
      return { ...state, importing: false, importResult: action.payload };
    case IMPORT_JSON_PAYLOAD_ERROR:
      return { ...state, importing: false, importError: action.payload };
    case IMPORT_JSON_PAYLOAD_RESET:
      return { ...state, importing: false, importResult: null, importError: null };

    default:
      return state;
  }
}
